const toPrintableTagName = tag => {
  if (typeof tag === 'string' || typeof tag === 'number') {
    return String(tag).trim();
  }

  if (!tag || typeof tag !== 'object') return '';

  const label = tag.name ?? tag.label ?? tag.value;
  return typeof label === 'string' || typeof label === 'number'
    ? String(label).trim()
    : '';
};

export const formatPrintTags = tags =>
  (Array.isArray(tags) ? tags : [tags])
    .map(toPrintableTagName)
    .filter(Boolean)
    .join(', ');
